<template>
  <v-layout fill-height column>
    <v-container flex-fill>
      <div class="breath-content fill-width fill-height">
        <div class="question mt-9" v-html="title2"></div>
        <div class="d-flex justify-center align-end mt-7">
          <input type="number" placeholder="0" class="input-box"><span>회</span>
        </div>
      </div>
    </v-container>
    <FooterBtnsNext @before="$emit('before')" @next="$emit('next')" :current="current" :total="total" :disabledNext="disabledNext" />
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  props: {
    current: Number,
    total: Number,
  },
  data: () => ({
    title2: '들이쉬고 내쉬고를 몇 회 했습니까? ',
  }),
  components: {
    FooterBtnsNext,
  },
  computed: {},
  methods: {},

}
</script>
